import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/hd_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-37ac10b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "canvas-ares",
  class: "container",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "收款回执单")
], -1))
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-title" }, "订单编号", -1))
const _hoisted_6 = { class: "col col-text" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-title" }, "付款日期", -1))
const _hoisted_9 = { class: "col col-text" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-title" }, "付款人", -1))
const _hoisted_12 = { class: "col col-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col col-title" }, "收款人"),
  /*#__PURE__*/_createElementVNode("div", { class: "col col-text" }, "深圳市汉德网络科技有限公司")
], -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-title" }, "费用类型", -1))
const _hoisted_16 = {
  key: 0,
  class: "col col-text"
}
const _hoisted_17 = {
  key: 1,
  class: "col col-text"
}
const _hoisted_18 = {
  key: 2,
  class: "col col-text"
}
const _hoisted_19 = {
  key: 3,
  class: "col col-text"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-title" }, "付款金额小写", -1))
const _hoisted_22 = { class: "col col-text" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-title" }, "付款金额大写", -1))
const _hoisted_25 = { class: "col col-text" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-title" }, "缴费车辆", -1))
const _hoisted_28 = { class: "col col-text" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"30px","background-color":"blue"} }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { id: "test-img" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.detail.orderNumber), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.detail.payDate), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.detail.phone), 1)
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          (_ctx.detail.typeExpense === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, "安装费"))
            : (_ctx.detail.typeExpense === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, "维修费"))
              : (_ctx.detail.typeExpense === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, "服务续费"))
                : (_ctx.detail.typeExpense === 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "对接费"))
                  : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.detail.price ? _ctx.detail.price * 0.01 : 0) + "元", 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.detail.upperPrice), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.orders, (orders, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(orders), 1))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveImage && _ctx.saveImage(...args)))
    }, "保存图片"),
    _hoisted_29,
    _hoisted_30
  ], 64))
}